<nb-sidebar class="side-bar" *ngIf="isOpen" right tag="right" fixed>
    <nb-card>
        <div class="side-bar-header">
            <ng-content select="[header]"></ng-content>
            <nb-icon class="pointer" icon="close" status="basic" (click)="sideBarService.toggle()"></nb-icon>
        </div>
        <ng-content select="[body]"></ng-content>
    </nb-card>
</nb-sidebar>
